import { compose } from 'ramda';
import {
  reportCommentRequest,
  deleteCommentRequest,
  deleteReplyRequest,
  toggleCommentEditing,
  reportReplyRequest
} from '../../store/actions/comments/commentsActions';

/**
 * Generates a "Show more" menu configuration array
 * given a dispatch function and
 * properties for the given comment
 * @param {Function} dispatch Redux dispatch function used to trigger actions
 * @param {Object} commentProperties Specific properties for the given comment (e.g. commentId)
 */
export const generateMenuConfiguration = (
  dispatch,
  {
    commentId,
    contentId,
    isReported,
    canDelete,
    canEdit,
    rootId = null,
    canReport
  }
) => [
  {
    label: 'edit',
    icon: ['fal', 'pencil-alt'],
    onClick: () => dispatch(toggleCommentEditing({ commentId, rootId })),
    isVisible: canEdit
  },
  {
    label: isReported ? 'reported' : 'report',
    icon: ['fal', 'flag'],
    onClick: rootId
      ? () => dispatch(reportReplyRequest({ contentId, commentId, rootId }))
      : () => dispatch(reportCommentRequest({ contentId, commentId })),
    isDisabled: isReported,
    isVisible: canReport
  },
  {
    label: 'delete',
    icon: ['fal', 'trash-alt'],
    onClick: rootId
      ? () => dispatch(deleteReplyRequest({ contentId, commentId, rootId }))
      : () => dispatch(deleteCommentRequest({ contentId, commentId })),
    isVisible: canDelete
  }
];

/**
 * Given a configuration array, maps only
 * items that are visible
 * @param {Array} config Menu configuration array
 */
export const mapVisibleItems = (config) =>
  config.reduce(
    (acc, configItem) => (configItem.isVisible ? [...acc, configItem] : acc),
    []
  );

export default (dispatch, commentProperties) =>
  compose(mapVisibleItems, generateMenuConfiguration)(
    dispatch,
    commentProperties
  );
